<template>
  <div class="home">
    <section class="card_section">
      <div class="container">
        <div class="row justify-content-center">
          <h4 class="top-heading">Your are Ready!</h4>
          <template v-if="car && 'img' in car.data">
          <a
            href="JavaScript:void(0)"
            ><img
              v-show="isImageLoaded"
              :src="getImgUrl(car.data.img)"
              alt="{{car.data.name}}"
              @load="loaded"
          /></a>
          <img
            v-if="!isImageLoaded"
            :src="'/lostsailor/images/loader.gif'"
          />
        </template>
        <template v-if="car && 'video' in car.data">
          <video class="badge-item-stat-video h-10" autoplay loop muted>
            <source :src="getImgUrl(car.data.video, 1)" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </template>
        <div class="row justify-content-center next_btn">
          <div class="col-sm-3 text-center ml-lg-2 just">
        <a
              href="#"
              class="text-center position-relative"
              @click.prevent="resetCar()"
            >
              <div class="fixed_btn">
                <img src="images/login.png" alt="" class="w-25 btn_lg" />
                <div class="text-center test">
                  <h3 class="text-center pulse loginBtn">Reset</h3>
                </div>
              </div>
            </a>
          </div>
        </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import router from "@/router";
import ApiService from '@/services'
import { mapState } from 'vuex'
import { useToast } from 'vue-toastification'
const toast = useToast()
export default {
  name: "Race",
  data() {
    return {
      countryStrokeColor:"#fa0909",
      legendBorderRadius:1,
      showReadyButton:false,
      location:null,
      authenticator:null,
    };
  },
  computed: mapState([
    // map this.count to store.state.count
    'car'
  ]),
  async created() {
      await ApiService.getCar((car) => this.$store.commit('addCar',car));
  },
  mounted() {
    if (!localStorage.getItem("wax_user")) {
      router.push("/login");
    }
    this.authenticator = localStorage.getItem("ual-session-authenticator");
  },
  methods: {
    getImgUrl(pet,isVid) {
      return ApiService.getImgUrl(pet,isVid);
    },
    async resetCar(){
      if(this.car.selectedCar){
        await ApiService.resetCar(this.car.selectedCar.id,(res) => {
          if (res.processed) {
            toast.success("Car Reset");
                router.push("/");
            }
        });
      }
    }
  },
};
</script>
<style scoped>
.content{
  height: 70%;
}
.select-card{
  width: 250px;
  position: absolute;
}
</style>